import { render, staticRenderFns } from "./MySliderExcursion.vue?vue&type=template&id=32d8bde6&"
import script from "./MySliderExcursion.vue?vue&type=script&setup=true&lang=js&"
export * from "./MySliderExcursion.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MySliderExcursion.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports